import React from 'react'
import PropTypes from 'prop-types'
import './style.css'
import ArrowRight from "../_icons/ArrowRight"
import {Transition, TransitionGroup} from 'react-transition-group'


const NRTBreadcrumb = ({
                           steps,
                           onStepClicked
                       }) => {
    return (

            <TransitionGroup className='nrt-breadcrumb'>
                {
                    steps.map((step, index) =>
                        <Fade key={'bread-' + index}
                              onClick={() => onStepClicked(step, index)}>

                            {step.display}

                            {
                                index !== steps.length - 1 &&
                                    <ArrowRight/>
                            }

                        </Fade>



                    )
                }
            </TransitionGroup>

    )
}


const Fade = ({children, ...props}) =>  {

    const defaultStyle = {
        transition: `all 400ms ease-in-out`,
        opacity: 0,
        transform: 'translate3d(-.5rem, 0 , 0 )'
    }

    const transitionStyles = {
        entering: {
            opacity: 0,
            transform: 'translate3d(-.5rem, 0 , 0 )'
        },
        entered:  {
            opacity: 1 ,
            transform: 'translate3d(0, 0 , 0 )'
        },
    };

    return (
        <Transition timeout={400} in={props.in}>
            {(state) => (
                <span
                    onClick={props.onClick}
                    style={{
                    ...defaultStyle,
                    ...transitionStyles[state],
                    ...props.style,
                }}>
                    {children}
                </span>
            )}
        </Transition>
    )
}




NRTBreadcrumb.propTypes = {
    steps: PropTypes.array.isRequired,
    onStepClicked: PropTypes.func,
}

NRTBreadcrumb.defaultProps = {
    onStepClicked: () => null
}

export default NRTBreadcrumb



// WEBPACK FOOTER //
// ./src/components/_common/Breadcrumb/index.js